var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',_vm._b({attrs:{"items":_vm.items,"dense":"","label":_vm.label,"hide-details":""},on:{"input":function($event){return _vm.$emit('input', $event !== '' ? $event : null)}}},'v-select',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }